import { Component, Input, ElementRef } from '@angular/core';

@Component({
  selector: 'app-possible-na-cell',
  templateUrl: './possible-na-cell.component.html',
  styleUrls: ['./possible-na-cell.component.scss'],
})
export class PossibleNaCellComponent {
  @Input() public text: string;
  @Input() public toolTip: string;
  constructor(public hostElement: ElementRef<HTMLElement>) {}
}
